
// Definición de defaults

export const defaultTipoAudiencia: TipoAudienciaProps = {
    idTipoAudiencia:    0,
    descripcion:        '',
    duracion:           30,
    oral:               false,
    tradicional:        false,
    medioPreparatorio:  false,
    citaSentencia:      false,
    activo:             false,
}

// Creación de interfaces

export interface TipoAudienciaProps{
    idTipoAudiencia:    number;
    descripcion:        string;
    duracion:           number;
    oral:               boolean;
    tradicional:        boolean;
    medioPreparatorio:  boolean;
    citaSentencia:      boolean;
    activo:             boolean;
}
